require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./data-visualization-data-visualization-with-d-3-work-with-data-in-d-3.json") })
        }
      }, "path---data-visualization-data-visualization-with-d-3-work-with-data-in-d-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---data-visualization-data-visualization-with-d-3-work-with-data-in-d-3!./.cache/json/data-visualization-data-visualization-with-d-3-work-with-data-in-d-3.json
// module id = 1980
// module chunks = 231608221292675